import React from "react";

import ModulePanel from "../../ModulePanel";

import RatingComponent from "react-rating";

import satisfactionQuestions from "../../../screens/Survey/Satisfaction/questions.json";

import Modal from "../../Modal";

import RatingResult from "./RatingResult";

class RatingMap extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            showModal: false
        };

        this.handleState = this.handleState.bind(this);
    }
    handleState(data){
        this.setState(data);
    }
    render(){
        const 
            { satisfaction_questions, surveys = [], isIndividual=false } = this.props,
            { showModal, title = "", parameter = "" } = this.state;

        return (
            <ModulePanel title={["Calificaciones promedio"]}>
                <div className="table-responsive">
                    <table className="table mg-b-0">
                        <tbody>
                            {satisfactionQuestions.map((question) => {
                                return (
                                    <tr key={question.value}>
                                        <td>
                                            <button className="link" onClick={() => {
                                                if (!isIndividual){
                                                    this.handleState({
                                                        title: question.text,
                                                        showModal: true,
                                                        parameter: question.value
                                                    });
                                                }
                                            }}>
                                                {question.text}
                                            </button>
                                        </td>
                                        <td>{((satisfaction_questions[question.value] || 0) * 100 / 5).toFixed(0)}%</td>
                                        <td style={{ width: "130px" }}>
                                            <RatingComponent
                                                emptySymbol="far fa-star mr-1"
                                                fullSymbol="fas fa-star mr-1 color-gold"
                                                readonly={true}
                                                initialRating={(satisfaction_questions[question.value] || 0)}
                                            />
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                {(!isIndividual) && (
                    <Modal
                        title={title}
                        isVisible={showModal}
                        onClose={() => { this.handleState({showModal: false}) }}>
                        <RatingResult value={parameter} surveys={surveys} handleState={this.props.handleState}/>
                        
                    </Modal>
                )}
            </ModulePanel>
        )
    }
}


export default RatingMap;